import { type GetServerSideProps } from 'next';

import { localizedContentService, agreementsService } from '../../services';

import { withEnhancedPageHandler } from '../../middlewares/withEnhancedPageHandler';

import { AgreementsTemplate } from '../../templates';

import { modifiers } from '../../data/shared';

import { type IAgreementsPageProps } from '../../modules/agreements/pageProps/@interfaces';
import { type IFooterContent } from '../../locales/@interfaces/shared/footerContent';
import { applyCorrelationIdHeader } from '../../utils/server/applyCorrelationIdHeader';

const Terms = (props: IAgreementsPageProps) => (
  <AgreementsTemplate {...props} />
);

const getServerSidePropsHandler: GetServerSideProps = async ({
  params,
  res,
  req,
}) => {
  const { slug = [] } = params;

  const [type = 'clientes', version = 'published'] = slug as string[];

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const customHeaders = applyCorrelationIdHeader(req.headers);

  const contents = await agreementsService(type, version, customHeaders);

  const { footerContent } = localizedContentService<{
    footerContent: IFooterContent;
  }>(
    'pt-BR',
    ['footerContent'],
    [modifiers.STATIC_ASSETS_PATH, modifiers.CURRENT_YEAR]
  );

  return {
    props: {
      contents,
      footerContent,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default Terms;
